import useTextHeight from "../projectCard/hooks/useTextHeight";
import LineCounter from "shared/components/TruncateTextOverflow/LineCounter";
import TruncateMarkup from "react-truncate-markup";

const TruncateTextOverflow = ({ children, overflowContainerRef }) => {
    const { getMeasures, annotationHeight } = useTextHeight(overflowContainerRef);

    if (!annotationHeight) {
        return (
            <LineCounter callback={getMeasures}>
                {children}
            </LineCounter>
        )
    }

    return (
        <TruncateMarkup lines={annotationHeight}>
            {children}
        </TruncateMarkup>
    )
}

export default TruncateTextOverflow;import useTextHeight from "../projectCard/hooks/useTextHeight";
import LineCounter from "shared/components/TruncateTextOverflow/LineCounter";
import TruncateMarkup from "react-truncate-markup";

const TruncateTextOverflow = ({ children, overflowContainerRef }) => {
    const { getMeasures, annotationHeight } = useTextHeight(overflowContainerRef);

    if (!annotationHeight) {
        return (
            <LineCounter callback={getMeasures}>
                {children}
            </LineCounter>
        )
    }

    return (
        <TruncateMarkup lines={annotationHeight}>
            {children}
        </TruncateMarkup>
    )
}

export default TruncateTextOverflow;